<template>
  <v-btn
    color="primary"
    outlined
    class="text-uppercase border-bold gray-550"
    @click="onClick"
  >
    <img
      src="/images/play_icon_blue.svg"
      width="25px"
    >
    Assista ao videocast
  </v-btn>
</template>
<script>
import { mapGetters } from "vuex";
import ActiveTabMixin from './ActiveTabMixin'

export default {
  mixins: [ActiveTabMixin],
  computed: {
    ...mapGetters(['module','contents']),
  },
  methods: {
    onClick(){
      const tab = this.contents.length
      console.log(tab)
      this.activeTab = tab
    }
  }
}
</script>
